import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

/** DEVON: 2025-01-09 - we should get the name of this FILE fixed ( the class name, the selector name, and the file name: all different ) */
@FormComponentLookup('form-producer-file-upload')
@Component({
    selector: 'app-form-producer-file-upload',
    templateUrl: './producer-file-upload.component.html',
    styleUrls: ['./producer-file-upload.component.scss'],
    standalone: false
})
export class ProducerFileUploadFormComponent extends FormEntryComponentClass {
  
  @ViewChild('entryRef') entryRef: ElementRef;
  value: any = [];

  constructor() {
    super();
  }
}